// =========================================================================
// Loop glyphs. Fork-owned (zone C), P5b lane.
//
// `seed/loops.ts` carries each loop's glyph as raw SVG path data, exactly as
// the demo authored it. Rendering that would mean `dangerouslySetInnerHTML`,
// which `scripts/oem/check-no-handler-strings.mjs` rejects and which has no
// business being on a page that renders trusted, compiled data anyway.
//
// The five Lucide icons below are the ones `shared/oem-nav.ts` already puts
// beside these loops in the sidebar, so the glyph on the tile and the glyph in
// the nav are the same mark.
//
// UI layer.
// =========================================================================

import { BarChart3, Lightbulb, RefreshCw, RotateCw, ShieldCheck, TrendingUp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { LoopId } from '../../shared/seed/loops';

/** Loop id → the mark the sidebar uses for it. */
export const LOOP_ICON: Readonly<Record<LoopId, LucideIcon>> = {
  component: RotateCw,
  warranty: ShieldCheck,
  learning: Lightbulb,
  commercial: TrendingUp,
  planning: BarChart3,
};

/** The section's own mark. */
export const LOOPS_SECTION_ICON = RefreshCw;

/** A loop's mark, falling back to the section mark for an unknown id. */
export const iconForLoop = (id: string): LucideIcon =>
  LOOP_ICON[id as LoopId] ?? LOOPS_SECTION_ICON;
